import { T } from "react-translator-component";
import { Typography, Avatar } from "@mui/material";
import {
  convertUserImage,
  displayUserName,
  displayUserNickname
} from "../../../../util/utils";
import { colors } from "../../../../common/colors";
import profile from "../../../../assets/images/profile_img.png";
import SafeTextWithLinks from "../../SafeTextWithLinks";
import Thumbnail from "../../Thumbnail";
import Likes from "../Likes";

interface Props {
  comment: any;
  highlightWords: string[];
}

export default function CommentDetail({ comment, highlightWords }: Props) {
  const displayedUserIcon = () => {
    if (comment?.is_anonymous === 3) return profile

    return comment?.user?.image ? convertUserImage(comment.user.image) : profile
  }

  const displayedUserName = () => {
    let name = ""
    switch (comment.is_anonymous) {
      case 3:
        name = T("mng_anonymous")
        break;
      case 2:
        name = displayUserName(comment?.user?.name)
        break;
      default:
        name = displayUserNickname(comment?.user?.nickname)
    }
    return name
  }

  return (
    <>
      <div style={styles.container}>
        <div style={styles.userIcon}>
          <Avatar
            alt={comment.user_nickname}
            style={styles.avatar}
            src={displayedUserIcon()}
          />
        </div>

        <div style={styles.contentBox}>
          <Typography
            sx={styles.name}
            variant="body2"
          >
            {displayedUserName()}
          </Typography>

          <div style={styles.body}>
            {comment?.images?.length !== 0 && (
              <Thumbnail item={comment} type="comments" />
            )}

            <SafeTextWithLinks text={comment?.content} highlightWords={highlightWords}/>
          </div>
        </div>

        <div style={styles.favoriteContainer}>
          <Likes
            iconSize={"sm"}
            liketype={"comment"}
            item={comment}
          />
        </div>
      </div>
    </>
  );
};

const styles = {
  container: {
    marginBottom: 16,
    display: "flex",
    width: "100%",
  },

  userIcon: {
    width: "40px",
  },

  contentBox: {
    width: "100%"
  },

  body: {
    textAlign: "left" as const
  },

  avatar: {
    width: "30px",
    height: "30px",
    borderRadius: "50%",
    marginRight: "10px",
  },

  name: {
    color: colors.farm_black,
    fontSize: 12,
    textAlign: "left" as const
  },

  content: {
    userSelect: "text" as const,
    fontSize: 18,
    fontFamily: "mplus-1c-regular",
    wordWrap: "break-word" as const,
    margin: 0,
    textAlign: "left" as const
  },

  favoriteContainer: {
    width: "30px",
    paddingTop: "9px",
    textAlign: "center" as const,
  },

}